<template>
  <v-app id="callbackpage">
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card
              class="mx-auto"
              max-width="444"
              outlined
            >
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="overline mb-4">
                    processing
                  </div>
                  <v-list-item-title class="headline mb-1">
                    Checking authorization
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    You will be redirected to the application any moment.
                    If this does not happen, please contact our support.
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

            <!-- <v-card-actions>
              <v-btn text>
                Button
              </v-btn>
              <v-btn text>
                Button
              </v-btn>
            </v-card-actions> -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    data: () => ({}),
  }
</script>

<script>
  import mgr from '@/services/securityService'

  export default {
    data: () => ({}),
    created: async function () {
      await this.$store.dispatch('HandleLoginCallback')
    },
  }
</script>
